<template>
    <div class="page_body">
        <div class="data_main">
            <div class="data_group" v-if="power.indexOf('1')>=0">
                <el-button type="primary" size="small" icon="el-icon-plus" @click="openAdd">新增</el-button>
            </div>
            <div class="data_table mt18">
                <el-table :data="listData" style="width: 100%" v-loading="isRequestLoading">
                    <el-table-column prop="account" label="用户账号" min-width="100px" align="center"></el-table-column>
                    <el-table-column prop="nickname" label="用户昵称" min-width="100px" align="center"></el-table-column>
                    <el-table-column prop="roleName" label="用户角色" min-width="100px" align="center"></el-table-column>
                    <el-table-column prop="address" label="操作" align="center" v-if="power.indexOf('2')>=0 || power.indexOf('3')>=0">
                        <template slot-scope="scope">
                          <el-button type="text" @click="openEdit(scope.row)" v-if="power.indexOf('2')>=0 && scope.row.account!='admin'">编辑</el-button>
                          <el-button type="text" @click="delAdminuser(scope.row.id)" v-if="power.indexOf('3')>=0 && scope.row.account!='admin'">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <el-dialog class="popup_dialog" title="修改当前密码" :visible.sync="password" :close-on-click-modal="false" :show-close="false" :destroy-on-close="true" width="600px">
              <el-form ref="formPwd" :model="formPwd" :rules="rulesPwd" label-width="120px" size="small">
                <el-form-item label="输入原密码：" prop="password">
                  <el-input v-model="formPwd.password" placeholder="请输入原密码" show-password></el-input>
                </el-form-item>
                  <el-form-item label="输入新密码：" prop="newPassword">
                    <el-input v-model="formPwd.newPassword" placeholder="请输入新密码" show-password></el-input>
                  </el-form-item>
        
                  <el-form-item label="确认密码：" prop="newPassWordAgain">
                    <el-input v-model="formPwd.newPassWordAgain" placeholder="请输入新密码" show-password></el-input>
                  </el-form-item>
                  <el-form-item>
                      <el-button type="primary" :loading="isSubmitLoading" @click="postPwd('formPwd')">提  交</el-button>
                      <el-button @click="password=false">关  闭</el-button>
                  </el-form-item>
              </el-form>
            </el-dialog>
            <el-dialog class="popup_dialog" title="新增角色" :visible.sync="addDialog" :close-on-click-modal="false" :show-close="false" :destroy-on-close="true" width="600px">
              <el-form ref="formPwd" :model="formAdd" :rules="rulesAdd" label-width="120px" size="small">
                  <el-form-item label="用户账号：" prop="account">
                    <el-input v-model="formAdd.account" placeholder="请输入用户账号"></el-input>
                  </el-form-item>
                  <el-form-item label="用户昵称：" prop="nickname">
                    <el-input v-model="formAdd.nickname" placeholder="请输入用户昵称"></el-input>
                  </el-form-item>
                  <el-form-item label="用户角色：" prop="roleId">
                    <el-select v-model="formAdd.roleId">
                        <el-option v-for="(item,index) in option" :key="index" :label="item.roleName" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
        
                  <el-form-item label="输入新密码：" prop="password">
                    <el-input v-model="formAdd.password" placeholder="请输入新密码" show-password></el-input>
                  </el-form-item>
        
        
                  <el-form-item label="确认密码：" prop="newPassWordAgain">
                    <el-input v-model="formAdd.newPassWordAgain" placeholder="再次输入新密码" show-password></el-input>
                  </el-form-item>
                  <el-form-item>
                      <el-button type="primary" :loading="isSubmitLoading" @click="postAdminuser('formPwd')">提  交</el-button>
                      <el-button @click="addDialog=false">关  闭</el-button>
                  </el-form-item>
              </el-form>
            </el-dialog>
            <el-dialog class="popup_dialog" title="修改角色" :visible.sync="editDialog" :close-on-click-modal="false" :show-close="false" :destroy-on-close="true" width="600px">
              <el-form ref="formEdit" :model="formEdit" :rules="rulesEdit" label-width="120px" size="small">
                  <el-form-item label="用户账号：" prop="account">
                    <el-input v-model="formEdit.account" placeholder="请输入用户账号"></el-input>
                  </el-form-item>
                  <el-form-item label="用户昵称：" prop="nickname">
                    <el-input v-model="formEdit.nickname" placeholder="请输入用户昵称"></el-input>
                  </el-form-item>
                  <el-form-item label="用户角色：" prop="roleId">
                    <el-select v-model="formEdit.roleId">
                        <el-option v-for="(item,index) in option" :key="index" :label="item.roleName" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="修改密码" class="changePwd">
                    <div class="button" @click="changePwd">点击修改</div>
                  </el-form-item>
                  <!-- <div class="changePwd">
                    <div class="name">修改密码</div>
                  </div> -->
                  <el-form-item>
                      <el-button type="primary" :loading="isSubmitLoading" @click="putAdminuser('formEdit')">提  交</el-button>
                      <el-button @click="editDialog=false">关  闭</el-button>
                  </el-form-item>
              </el-form>
            </el-dialog>
          <pagination :size="listQuery.size" :total="pages.total" :current="listQuery.page" :pages="pages.pages" @pageChange="pageChange"/>
        </div>
    </div>
</template>

<script>
import pagination from '../../components/pagination'
import {mapState} from "vuex";
import {getAdminuser,postAdminuser,putAdminuser,delAdminuser,getSysroleList,postPassword,getAdminuserOne} from "@/api";
import {splitTTimes} from '../../utils/dateFormat'
export default {
  name: "userRole",
  data () {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.formAdd.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.formPwd.newPassword) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      addDialog: false,
      editDialog: false,
      imageURL: window.config.imageURL,
      splitTTimes,
      listQuery: {
        nickname:'',
        phone:'',
        page: 1,
        size: 10
      },
      pages: {
        total: 0,
        pages: 0
      },
      isSubmitLoading: false,
      isSearchLoading: false,
      isRequestLoading: false,
      listData: [],
      option:[],
      formAdd:{
        account:'',
        nickname:'',
        roleId:'',
        password:'',
        newPassWordAgain:'',
      },
      rulesAdd: {
        account: [
          { required: true, message: '请输入用户账号', trigger: 'blur' },
        ],
        nickname: [
          { required: true, message: '请输入用户昵称', trigger: 'blur' },
        ],
        roleId: [
          { required: true, message: '请选择用户角色', trigger: 'change' },
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
        ],
        newPassWordAgain: [
          { validator: validatePass, trigger: 'blur' }
        ]
      },
      formEdit:{
        account:'',
        nickname:'',
        roleId:'',
        password:'',
        newPassWordAgain:'',
      },
      rulesEdit: {
        account: [
          { required: true, message: '请输入用户账号', trigger: 'blur' },
        ],
        nickname: [
          { required: true, message: '请输入用户昵称', trigger: 'blur' },
        ],
        roleId: [
          { required: true, message: '请选择用户角色', trigger: 'change' },
        ]
      },
      formPwd:{
        id:'',
        password:'',
        newPassword:'',
        newPassWordAgain:'',
      },
      password:false,
      rulesPwd: {
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
        ],
        newPassword: [
          { required: true, message: '请输入密码', trigger: 'blur' },
        ],
        newPassWordAgain: [
          { validator: validatePass2, trigger: 'blur' }
        ]
      },
      power:false
    }
  },
  computed: {
    ...mapState({
      listKeepAlive: state => state.app.listKeepAlive,
    })
  },
  activated () {
    this.getSysroleList()
    this.getList()
  },
  created(){
    this.power = JSON.parse(localStorage.getItem('userRole')).power[8]
  },
  methods: {
    changePwd(){
      this.editDialog = false
      this.setPassword(this.formEdit.id)
    },
    openAdd(){
      this.formAdd={
        account:'',
        nickname:'',
        roleId:'',
        password:'',
        newPassWordAgain:'',
      }
      this.addDialog = true
    },
    openEdit(data){
      getAdminuserOne(data.id).then(res=>{
        this.formEdit={
          id:data.id,
          account:res.data.account,
          nickname:res.data.nickname,
          roleId:res.data.roleId,
          password:res.data.password,
        }
      })
      this.editDialog = true
    },
    setPassword(id){
      this.formPwd = {
        id:id,
        password:'',
        newPassword:'',
        newPassWordAgain:''
      }
      this.password=true
    },
    postPwd(formName){
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.isSubmitLoading = true
          postPassword({
            data: this.formPwd
          }).then(res => {
            this.isSubmitLoading = false
            if (res.code === 0) {
              this.$message({
                message: '修改密码成功',
                type: 'success',
                showClose: true,
              });
              this.password = false
              this.getList()
            }
          }).catch(() => {
            this.isSubmitLoading = false
          })
        }
      })
    },
    getSysroleList(){
      getSysroleList().then(res=>{
        this.option = res.data
      })
    },
    delAdminuser (id) {
      this.$confirm('此操作将永久删除该管理员, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        delAdminuser(id).then(res => {
          if (res.code === 0) {
            this.$message({
              message: '管理员删除成功',
              type: 'success',
              showClose: true,
            });
            this.getList()
          }
        })
      }).catch(() => {});
    },
    getList () {
      this.isRequestLoading = true
      getAdminuser(this.listQuery).then(res => {
        this.isRequestLoading = false
        this.isSearchLoading = false
        if (res.code === 0) {
          this.isShow = true
          this.listData = res.data.records
          this.pages.total = res.data.total
          this.pages.pages = res.data.pages
        }
      }).catch(() => {
        this.isRequestLoading = false
        this.isSearchLoading = false
      })
    },
    toSearchList () {
      this.listQuery.page = 1;
      this.isSearchLoading = true;
      this.getList()
    },
    pageChange (e) {
      this.listQuery.page = e.current
      this.listQuery.size = e.size
      this.getList()
    },
    putAdminuser(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.isSubmitLoading = true
          putAdminuser({
            data: this.formEdit
          }).then(res => {
            this.isSubmitLoading = false
            if (res.code === 0) {
              this.$message({
                message: '修改管理员成功',
                type: 'success',
                showClose: true,
              });
              this.editDialog = false
              this.getList()
            }
          }).catch(() => {
            this.isSubmitLoading = false
          })
        }
      })
    },
    postAdminuser(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.isSubmitLoading = true
          postAdminuser({
            data: this.formAdd
          }).then(res => {
            this.isSubmitLoading = false
            if (res.code === 0) {
              this.$message({
                message: '新增管理员成功',
                type: 'success',
                showClose: true,
              });
              this.addDialog = false
              this.getList()
            }
          }).catch(() => {
            this.isSubmitLoading = false
          })
        }
      })
    }
  },
  components: {
    pagination
  }
}
</script>
<style lang="scss" scoped>
.picImg{
  max-width: 120px;
}
.changePwd{
  margin-top: 140px;
}
.button{
  cursor: pointer;
  color: #4288f2;
  margin-left: 20px;
}
</style>
